import React, { useState } from 'react';
import './Controls.css';

function AdminTab() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false); // ⬅️ new state

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('❌ Please choose a file before uploading.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);   // ⬅️ show spinner
    setMessage('');

    try {
      const res = await fetch('/api/ingest', {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      if (data.success) {
        setMessage('✅ Ingest complete.');
      } else {
        setMessage(`⚠️ Error: ${data.error}`);
      }
    } catch (err) {
      console.error('Upload error:', err);
      setMessage('⚠️ Something went wrong while uploading.');
    } finally {
      setLoading(false); // ⬅️ hide spinner
    }
  };

  return (
    <div>
      <h2>Admin: Ingest Vedam</h2>

      <input
        type="file"
        className="big-input file-input"
        onChange={handleFileChange}
      />

      <button onClick={handleUpload} disabled={loading}>
        {loading ? 'Uploading...' : 'Upload & Ingest Vedam'}
      </button>

      {/* Spinner or message */}
      {loading && <div className="spinner"></div>}
      {message && <div className="error-message">{message}</div>}
    </div>
  );
}

export default AdminTab;